import cn from 'classnames';
import * as Draft from 'draft-js';
import * as React from 'react';

import { findWithRegex } from '../utils';

import s from './MathOperatorDecorator.module.scss';

type Props = React.PropsWithChildren<{
  offsetKey: string;
}>;

/**
 * Функция-стратегия позволяет из сплошного текста вычислить границы отрезков,
 * для которых надо применить текущий декоратор
 *
 * @param contentBlock - блок, над которым применяется декоратор
 * @param callback - вызывается с координатами текста start end, для которых надо применить декоратор
 */
const formFieldStrategy = (
  contentBlock: Draft.ContentBlock,
  callback: (startIndex: number, endIndex: number) => void
) => {
  findWithRegex(/[+\-*/()<>=]/g, contentBlock, callback);
};

const View: React.FC<Props> = ({ offsetKey, children }: Props) => {
  let operatorText = '';

  if (Array.isArray(children) && children.length) {
    // Вытаскиваем, какой оператор сейчас рендерится
    operatorText = children[0].props?.text || '';
  }

  const isEqualSymbol = operatorText === '=';

  const isOperatorSymbol = !isEqualSymbol;

  return (
    <span
      className={cn(
        s.view,
        isEqualSymbol && s.view_colorEqual,
        isOperatorSymbol && s.view_colorOperator
      )}
      data-offset-key={offsetKey}
    >
      {children}
    </span>
  );
};

/**
 * Декоратор MathOperator подкрашивает математические операторы и скобки цветом
 */
export const MathOperatorDecorator: Draft.DraftDecorator = {
  strategy: formFieldStrategy,
  component: View,
};
